// @flow
import React from 'react'

import styles from './styles'

export const Loader = () => (
  <div style={styles.loader} />
)

export default Loader
